import {createSlice} from '@reduxjs/toolkit';
import AdminApi from "../../../api/AdminApi";
import {showNotification} from "./notification";

type State = {
    data: { [key: number]: { value: string, label: string } },
    isLoading: boolean,
    error: Object | null,
    cellId: number | null
}

const initialState = {
    data: {},
    isLoading: false,
    error: null,
	cellId: null
}

const tags = createSlice({
    name: 'tags',
    initialState,
    reducers: {
        fetchTagsStart: (state: State) => {
            state.isLoading = true;
            state.error = null;
        },
        fetchTagsSuccess: (state: State, action) => {
			const cellId = action.payload.cellId;
            // @ts-ignore
            if (action.payload && action.payload.data) {
                const newData = action.payload.data.reduce((obj: Object, item: { brandId: string, tags: Array<{ id: string, name: string }> }) => {
                    return {
                        ...obj,
                        [item['brandId']]: item.tags.map(tag => {
                            return {
                                value: `${item['brandId']}-${tag.id}`,
                                label: tag.name
                            }
                        })
                    }
                }, {});

                // Load additional tags in case that edit page has old tags that are not present in current dataset
                if (action.payload.additionalTags && action.payload.additionalTags.length) {
                    action.payload.additionalTags.forEach((additionalTag: string) => {
                        const explodedTag = additionalTag.split('-');
                        const brandId = explodedTag[0];
                        const additionalTagName = explodedTag[1];

                        if (newData[brandId] && !newData[brandId].some((tag: {value: string, label: string}) => tag.value === additionalTag)) {
                            const brandName = newData[brandId][0] ? newData[brandId][0].label.split(' - ')[0] : null;

                            if (brandName) {
                                newData[brandId].push({ value: additionalTag, label: `${brandName} - ${additionalTagName}` });
                            }
                        }
                    });
                }

            	state.data = {
					...state.data,
					[cellId]: newData
				}
            }
            state.isLoading = false;
            state.error = false;
            state.cellId = cellId;
        },
        fetchTagsFailed: (state: State, action) => {
            state.isLoading = false;
            state.error = action.payload
        },
        resetTags: (state: State, action) => {
            if (action.payload.cellId) {
                delete state.data[action.payload.cellId];
            }
        }
    }
});

// Actions
export const {
    fetchTagsStart,
    fetchTagsSuccess,
    fetchTagsFailed,
    resetTags
} = tags.actions;

export default tags.reducer;

// Thunk
export const fetchTags = (brands: string, type: string, search: string, additionalTags: Array<string>, cellId: number) => async (dispatch: Function) => {
    try {
        dispatch(fetchTagsStart());
        const api = new AdminApi();
        const result = await api.getTags(brands, type, search);
        const payload = {
        	data: result,
            additionalTags,
			cellId
		}
        dispatch(fetchTagsSuccess(payload));
    } catch (err: any) {
        dispatch(fetchTagsFailed(err));
		dispatch(showNotification('error', err.message));
	}
}
